import { useEffect, RefObject } from "react";

/**
 * Hook that calls handler when user clicks outside of the passed refs
 * @param refs - Array of refs to track
 * @param handler - Callback to call when clicked outside
 * @param enabled - Whether the hook is enabled (default: true)
 */
export function useClickOutside(refs: RefObject<HTMLElement | null>[], handler: () => void, enabled: boolean = true) {
    useEffect(() => {
        if (!enabled) return;

        const handleClickOutside = (e: MouseEvent) => {
            const target = e.target as Node;

            // Check if click is outside all refs
            const clickedOutside = refs.every((ref) => !ref.current?.contains(target));

            if (clickedOutside) {
                handler();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [refs, handler, enabled]);
}
